module.exports = __webpack_public_path__ + "img/kaitlyn.5b9df6a5.jpg";